var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fieldset"},[(_vm.form)?[_c('h3',{staticClass:"fieldset-heading"},[_vm._v("Other")]),_c('Other',{model:{value:(_vm.form.other),callback:function ($$v) {_vm.$set(_vm.form, "other", $$v)},expression:"form.other"}})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }